
define('ldsh!modules/form_editor/templates/editor_advanced_date', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (!isPopup) { ;
__p += '\n<div class="ed-form-group ed-advanced-item">\n  <label for="invalid-date-message"\n    data-i18n="formEditor.invalidDateMessageLabel"></label>\n  <input id="invalid-date-message"\n    type="text"\n    name="invalid-date-message"\n    class="form-control ed-form-item-full js-invalid-date-message"\n    value="' +
((__t = ( invalidDateMessage )) == null ? '' : __t) +
'" />\n</div>\n\n<div class="ed-form-group ed-advanced-item">\n  <label for="invalid-date-agelimit-message"\n    data-i18n="formEditor.invalidDateAgeLimitMessageLabel"></label>\n  <input id="invalid-date-agelimit-message"\n    type="text"\n    name="invalid-date-agelimit-message"\n    class="form-control ed-form-item-full js-invalid-date-agelimit-message"\n    value="' +
((__t = ( invalidDateAgeLimitMessage )) == null ? '' : __t) +
'" />\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

